module.exports = __webpack_public_path__ + "img/service-231.dbe4019a.png";